import '../scss/recipes.scss';

import recipeCarousel from './scripts/splide-recipes';

// import navigation from './scripts/navigation';

if(document.readyState !== 'loading') {
	runOnStart();
}
else {
	document.addEventListener('DOMContentLoaded', function () {
			runOnStart()
	});
}

function runOnStart() {
	// Run your code here
	// console.log('recipes.ts loaded')
	recipeCarousel();
}